import { z } from 'zod';
import { IdSchema, TimestampSchema } from './common.js';

export const ConversationStatusSchema = z.enum(['active', 'closed']);
export type ConversationStatus = z.infer<typeof ConversationStatusSchema>;

export const ConversationOutcomeSchema = z.enum(['won', 'lost', 'in_progress', 'abandoned']);
export type ConversationOutcome = z.infer<typeof ConversationOutcomeSchema>;

export const ConversationSchema = z.object({
  id: IdSchema,
  customerId: IdSchema,
  topicId: IdSchema,
  repId: IdSchema,
  status: ConversationStatusSchema,
  outcome: ConversationOutcomeSchema.nullable(),
  outcomeNotes: z.string().nullable(),
  closedAt: TimestampSchema.nullable(),
  createdAt: TimestampSchema,
  updatedAt: TimestampSchema,
});
export type Conversation = z.infer<typeof ConversationSchema>;

export const CreateConversationSchema = z.object({
  customerId: IdSchema,
  topicId: IdSchema,
});
export type CreateConversationInput = z.infer<typeof CreateConversationSchema>;

export const UpdateConversationSchema = z.object({
  status: ConversationStatusSchema.optional(),
  outcome: ConversationOutcomeSchema.nullable().optional(),
  outcomeNotes: z.string().nullable().optional(),
});
export type UpdateConversationInput = z.infer<typeof UpdateConversationSchema>;

export const ListConversationsQuerySchema = z.object({
  status: ConversationStatusSchema.optional(),
  outcome: ConversationOutcomeSchema.optional(),
  topicId: IdSchema.optional(),
  repId: IdSchema.optional(),
  customerId: IdSchema.optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(25),
});
export type ListConversationsQuery = z.infer<typeof ListConversationsQuerySchema>;
